import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

export const LANGUAGE_NAME_TO_CODE = {
  English: 'en',
  Hebrew: 'he',
};

const supportedLngs = Object.values(LANGUAGE_NAME_TO_CODE);

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: 'en',
    supportedLngs,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    ns: ['common'],
    defaultNS: 'common',
    load: 'currentOnly',
    cleanCode: true,
  });

export default i18n;

